import axios from "axios";
import moment from "moment";

import {
  queryString
} from "object-query-string";
import {
  OPEN_KEYWORDS_CREATE_MODAL,
  SET_KEYWORDS,
  SET_KEYWORD,
  SET_KEYWORDS_SEARCH,
  SET_KEYWORDS_SORT,
  ADD_KEYWORD_TO_BE_REMOVED,
  SET_TAGS,
} from "./types";

import {
  displayNotification
} from "./notificationActions";
import {
  toggleDisableButton
} from "./configActions";
export const keywordModal = (visibility) => (dispatch) => {
  dispatch({
    type: OPEN_KEYWORDS_CREATE_MODAL,
    payload: visibility,
  });
};

export const createKeywords = (
  domainId,
  keywords,
  pageNum,
  search,
  sort,
  limit
) => (dispatch) => {
  dispatch(toggleDisableButton(true));
  axios
    .post(`keywords/${domainId}`, {
      keywords: keywords,
    })
    .then((response) => {
      dispatch(setKeywords(domainId, pageNum, search, sort, limit)).then(() => {
        dispatch(toggleDisableButton(false));
        dispatch(
          displayNotification({
            type: "success",
            message: "Your keywords will be imported shortly.",
          })
        );
        dispatch(keywordModal(false));
      });
    })
    .catch((error) => {
      dispatch(toggleDisableButton(false));
      if (error.response.status) {
        dispatch(
          displayNotification({
            type: "error",
            message: error.response.data.error
          })
        );
      } else {
        dispatch(
          displayNotification({
            type: "error",
            message: "Not able to perform this action, please contact support team."
          })
        );
      }
    });
};

export const searchKeywords = (domainId, pageNum, search, sort) => (
  dispatch
) => {
  dispatch({
    type: SET_KEYWORDS_SEARCH,
    payload: search,
  });
  dispatch(setKeywords(domainId, pageNum, search, sort));
};

export const sortKeywords = (domainId, pageNum, search, sort, limit) => (dispatch) => {
  dispatch({
    type: SET_KEYWORDS_SORT,
    payload: sort,
  });
  dispatch(setKeywords(domainId, pageNum, search, sort, limit));
};

export const setKeywords = (
  domainId,
  pageNum = 1,
  search,
  sort,
  limit = 15
) => (dispatch) => {
  let pageNumber = pageNum;
  if (pageNum === -Infinity) {
    pageNumber = 1;
  }
  let baseSearchPath = `keywords/${domainId}?pageNum=${pageNumber}&limit=${limit}`;
  if (search) {
    const query = queryString(search);
    baseSearchPath = `${baseSearchPath}&${query}`;
  }
  if (sort) {
    const sortOrder = queryString({
      sort: sort,
    });
    baseSearchPath = `${baseSearchPath}&${sortOrder}`;
  }
  axios
    .get(baseSearchPath)
    .then((response) => {
      const data = response.data;
      dispatch({
        type: SET_KEYWORDS,
        payload: data,
      });
    })
    .catch((error) => {});
  return Promise.resolve();
};

export const setTags = (
  domainId,
) => (dispatch) => {
  axios
    .get(`keywords/${domainId}/tags`)
    .then((response) => {
      const data = response.data;
      dispatch({
        type: SET_TAGS,
        payload: data.tags,
      });
    })
    .catch((error) => {});
  return Promise.resolve();
};

export const setKeyword = (domainId, keywordId, startDate, endDate) => (
  dispatch
) => {
  axios
    .get(
      `keywords/${domainId}/${keywordId}?startDate=${moment(startDate).format(
        "YYYY-MM-DD"
      )}&endDate=${moment(endDate).format("YYYY-MM-DD")}`
    )
    .then((response) => {
      const keyword = response.data.keyword;
      dispatch({
        type: SET_KEYWORD,
        payload: keyword,
      });
    })
    .catch((error) => {});
};

export const refreshKeyword = (
  domainId,
  keywordIds,
  pageNum,
  search,
  sort,
  limit) => (dispatch) => {

  axios
    .post(`keywords/${domainId}/manual/refresh`, {
      keywordIds: keywordIds
    })
    .then((response) => {
      dispatch(setKeywords(domainId, pageNum, search, sort, limit)).then(() => {
        dispatch(addTobeRemoved([]));
        dispatch(
          displayNotification({
            type: "success",
            message: "Your keywords ranking will be re-checked shortly.",
          })
        );
      });
    })
    .catch((error) => {
      if (error.response && (error.response.status === 403)) {
        dispatch(
          displayNotification({
            type: "error",
            message: "You can re-check 50 keywords at a time.",
          })
        );
      } else {
        dispatch(
          displayNotification({
            type: "error",
            message: "You can re-check ranks once per 2 hours.",
          })
        );
      }

    });

};

export const addTobeRemoved = (removalList) => (dispatch) => {
  dispatch({
    type: ADD_KEYWORD_TO_BE_REMOVED,
    payload: removalList,
  });
};

export const removeKeywords = (
  domainId,
  keywords,
  hideModal,
  pageNum,
  search,
  sort,
  limit
) => (dispatch) => {

  dispatch(toggleDisableButton(true));
  axios
    .delete(`keywords/${domainId}?ids=${keywords}`)
    .then((response) => {
      dispatch(setKeywords(domainId, pageNum, search, sort, limit)).then(() => {
        hideModal(false);
        dispatch(toggleDisableButton(false));
        dispatch(addTobeRemoved([]));
        dispatch(
          displayNotification({
            type: "success",
            message: "Keyword(s) data will be removed shortly.",
          })
        );
      });
    })
    .catch((error) => {
      dispatch(toggleDisableButton(false));
      if (error.response && (error.response.status === 403)) {
        dispatch(
          displayNotification({
            type: "error",
            message: "You can remove 50 keywords at a time.",
          })
        );
      } else {
        dispatch(
          displayNotification({
            type: "error",
            message: "Not able to perform this action, please contact support team.",
          })
        );
      }
    });
}


export const updateKeywords = (
  domainId,
  keywordIds,
  tags,
  hideModal,
  pageNum,
  search,
  sort,
  limit
) => (dispatch) => {
  dispatch(toggleDisableButton(true));
  axios
    .patch(`keywords/${domainId}`, {
      keywordIds: keywordIds,
      tags: tags
    })
    .then((response) => {
      dispatch(setKeywords(domainId, pageNum, search, sort, limit)).then(() => {
        hideModal(false);
        dispatch(toggleDisableButton(false));
        dispatch(addTobeRemoved([]));
        dispatch(
          displayNotification({
            type: "success",
            message: "Tag(s) successfully updated.",
          })
        );
      });
    })
    .catch((error) => {
      dispatch(toggleDisableButton(false));
      dispatch(
        displayNotification({
          type: "error",
          message: "Not able to perform this action, please contact support team.",
        })
      );
    });
};